export default __webpack_public_path__ + "static/media/4.b30602c5.svg";